import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/publish.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm publish <package-spec>
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/publish.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`Publishes a package to the registry so that it can be installed by name.`}</p>
    <p>{`By default npm will publish to the public registry. This can be
overridden by specifying a different default registry or using a
`}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/scope"
      }}><inlineCode parentName="a">{`scope`}</inlineCode></a>{` in the name, combined with a
scope-configured registry (see
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-json"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{`).`}</p>
    <p>{`A `}<inlineCode parentName="p">{`package`}</inlineCode>{` is interpreted the same way as other commands (like
`}<inlineCode parentName="p">{`npm install`}</inlineCode>{` and can be:`}</p>
    <ul>
      <li parentName="ul">{`a) a folder containing a program described by a
`}<a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` file`}</li>
      <li parentName="ul">{`b) a gzipped tarball containing (a)`}</li>
      <li parentName="ul">{`c) a url that resolves to (b)`}</li>
      <li parentName="ul">{`d) a `}<inlineCode parentName="li">{`<name>@<version>`}</inlineCode>{` that is published on the registry (see
`}<a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}><inlineCode parentName="a">{`registry`}</inlineCode></a>{`) with (c)`}</li>
      <li parentName="ul">{`e) a `}<inlineCode parentName="li">{`<name>@<tag>`}</inlineCode>{` (see `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}><inlineCode parentName="a">{`npm dist-tag`}</inlineCode></a>{`) that
points to (d)`}</li>
      <li parentName="ul">{`f) a `}<inlineCode parentName="li">{`<name>`}</inlineCode>{` that has a "latest" tag satisfying (e)`}</li>
      <li parentName="ul">{`g) a `}<inlineCode parentName="li">{`<git remote url>`}</inlineCode>{` that resolves to (a)`}</li>
    </ul>
    <p>{`The publish will fail if the package name and version combination already
exists in the specified registry.`}</p>
    <p>{`Once a package is published with a given name and version, that specific
name and version combination can never be used again, even if it is removed
with `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-unpublish"
      }}><inlineCode parentName="a">{`npm unpublish`}</inlineCode></a>{`.`}</p>
    <p>{`As of `}<inlineCode parentName="p">{`npm@5`}</inlineCode>{`, both a sha1sum and an integrity field with a sha512sum of the
tarball will be submitted to the registry during publication. Subsequent
installs will use the strongest supported algorithm to verify downloads.`}</p>
    <p>{`Similar to `}<inlineCode parentName="p">{`--dry-run`}</inlineCode>{` see `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-pack"
      }}><inlineCode parentName="a">{`npm pack`}</inlineCode></a>{`, which figures
out the files to be included and packs them into a tarball to be uploaded
to the registry.`}</p>
    <h3>{`Files included in package`}</h3>
    <p>{`To see what will be included in your package, run `}<inlineCode parentName="p">{`npx npm-packlist`}</inlineCode>{`.  All
files are included by default, with the following exceptions:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Certain files that are relevant to package installation and distribution
are always included.  For example, `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, `}<inlineCode parentName="p">{`README.md`}</inlineCode>{`,
`}<inlineCode parentName="p">{`LICENSE`}</inlineCode>{`, and so on.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If there is a "files" list in
`}<a parentName="p" {...{
            "href": "/cli/v8/configuring-npm/package-json"
          }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{`, then only the files
specified will be included.  (If directories are specified, then they
will be walked recursively and their contents included, subject to the
same ignore rules.)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If there is a `}<inlineCode parentName="p">{`.gitignore`}</inlineCode>{` or `}<inlineCode parentName="p">{`.npmignore`}</inlineCode>{` file, then ignored files in
that and all child directories will be excluded from the package.  If
`}<em parentName="p">{`both`}</em>{` files exist, then the `}<inlineCode parentName="p">{`.gitignore`}</inlineCode>{` is ignored, and only the
`}<inlineCode parentName="p">{`.npmignore`}</inlineCode>{` is used.`}</p>
        <p parentName="li"><inlineCode parentName="p">{`.npmignore`}</inlineCode>{` files follow the `}<a parentName="p" {...{
            "href": "https://git-scm.com/book/en/v2/Git-Basics-Recording-Changes-to-the-Repository#_ignoring"
          }}>{`same pattern
rules`}</a>{`
as `}<inlineCode parentName="p">{`.gitignore`}</inlineCode>{` files`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If the file matches certain patterns, then it will `}<em parentName="p">{`never`}</em>{` be included,
unless explicitly added to the `}<inlineCode parentName="p">{`"files"`}</inlineCode>{` list in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, or
un-ignored with a `}<inlineCode parentName="p">{`!`}</inlineCode>{` rule in a `}<inlineCode parentName="p">{`.npmignore`}</inlineCode>{` or `}<inlineCode parentName="p">{`.gitignore`}</inlineCode>{` file.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Symbolic links are never included in npm packages.`}</p>
      </li>
    </ul>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/developers"
      }}><inlineCode parentName="a">{`developers`}</inlineCode></a>{` for full details on what's
included in the published package, as well as details on how the package is
built.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`tag`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "latest"`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`If you ask npm to install a package and don't tell it a specific version,
then it will install the specified tag.`}</p>
    <p>{`Also the tag that is added to the package@version specified by the `}<inlineCode parentName="p">{`npm tag`}</inlineCode>{`
command, if no explicit tag is given.`}</p>
    <p>{`When used by the `}<inlineCode parentName="p">{`npm diff`}</inlineCode>{` command, this is the tag used to fetch the
tarball that will be compared with the local files by default.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`access`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 'restricted' for scoped packages, 'public' for unscoped packages`}</li>
      <li parentName="ul">{`Type: null, "restricted", or "public"`}</li>
    </ul>
    <p>{`When publishing scoped packages, the access level defaults to `}<inlineCode parentName="p">{`restricted`}</inlineCode>{`.
If you want your scoped package to be publicly viewable (and installable)
set `}<inlineCode parentName="p">{`--access=public`}</inlineCode>{`. The only valid values for `}<inlineCode parentName="p">{`access`}</inlineCode>{` are `}<inlineCode parentName="p">{`public`}</inlineCode>{` and
`}<inlineCode parentName="p">{`restricted`}</inlineCode>{`. Unscoped packages `}<em parentName="p">{`always`}</em>{` have an access level of `}<inlineCode parentName="p">{`public`}</inlineCode>{`.`}</p>
    <p>{`Note: Using the `}<inlineCode parentName="p">{`--access`}</inlineCode>{` flag on the `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` command will only set
the package access level on the initial publish of the package. Any
subsequent `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` commands using the `}<inlineCode parentName="p">{`--access`}</inlineCode>{` flag will not have an
effect to the access level. To make changes to the access level after the
initial publish use `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`dry-run`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Indicates that you don't want npm to make any changes and that it should
only report what it would have done. This can be passed into any of the
commands that modify your local installation, eg, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, `}<inlineCode parentName="p">{`update`}</inlineCode>{`,
`}<inlineCode parentName="p">{`dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{`, as well as `}<inlineCode parentName="p">{`pack`}</inlineCode>{` and `}<inlineCode parentName="p">{`publish`}</inlineCode>{`.`}</p>
    <p>{`Note: This is NOT honored by other network related commands, eg `}<inlineCode parentName="p">{`dist-tags`}</inlineCode>{`,
`}<inlineCode parentName="p">{`owner`}</inlineCode>{`, etc.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://npm.im/npm-packlist"
        }}>{`npm-packlist package`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scope"
        }}>{`npm scope`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm adduser`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-owner"
        }}>{`npm owner`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-deprecate"
        }}>{`npm deprecate`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}>{`npm dist-tag`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-pack"
        }}>{`npm pack`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-profile"
        }}>{`npm profile`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      